import Modal from 'react-modal';
import WarningIcon from '@mui/icons-material/Warning';
import CustomButtonSimple from '../../../../../components/CustomMiscellaneous/CustomButtonSimple';
import { ControloEQualidadeForm } from '.';
import { RelatorioControlo } from '../../../../../types';


export function ModalControloEQualidade({
    controloQualidadeFormOpen,
    setConfirmationModalOpen,
    setControloQualidadeFormOpen,
    confirmationModalOpen,
    relatoriControloState,
    relatorioControlo,
    pecaEntrega,
    fetchRelatorio
}: {
    controloQualidadeFormOpen: boolean,
    setConfirmationModalOpen: any,
    setControloQualidadeFormOpen: any,
    confirmationModalOpen: boolean,
    relatoriControloState: any,
    relatorioControlo?: RelatorioControlo,
    pecaEntrega : any,
    fetchRelatorio: any
}) {


    return (
        <Modal className={"justify-self-center flex w-full h-full p-5 z-[1000]"} isOpen={controloQualidadeFormOpen}>
            <Modal className={"justify-self-center flex w-full h-full p-96 z-[1000] justify-center"} isOpen={confirmationModalOpen}>
                <div className="bg-white opacity-100 flex flex-col w-96 rounded-md shadow-lg z-[1001] h-fit p-5">
                    <div className="flex items-center mb-2">
                        <WarningIcon style={{ fontSize: '3em', fill: '#c02d1a' }} />
                        <div className="text-2xl ml-4">Atenção!</div>
                    </div>
                    Existem alterações que não foram guardadas, tens a certeza que pretendes fechar o formulário?

                    <div className="flex w-full justify-between mt-2">
                        <CustomButtonSimple className="w-full" text="Sim" onClick={() => {
                            setConfirmationModalOpen(false);
                            setControloQualidadeFormOpen(false);
                            relatoriControloState.setHasChanges(false);
                        }} />
                        <CustomButtonSimple className="w-full" text="Não" onClick={() => setConfirmationModalOpen(false)} />
                    </div>

                </div>
            </Modal>
            <div className="bg-white opacity-100 flex flex-col w-full rounded-md shadow-lg z-[1001] max-h-full">
                <div className="flex w-full justify-between  bg-rodrimaq-red rounded-t-md p-3">
                    <div className="text-white font-bold">Relatório para controlo de qualidade</div>
                    <div className="text-white cursor-pointer hover:underline" onClick={() => {
                        relatoriControloState.hasChanges ?
                            setConfirmationModalOpen(true)
                            : setControloQualidadeFormOpen(false)
                    }}>Fechar</div>
                </div>
                {controloQualidadeFormOpen ? <ControloEQualidadeForm
                    relatoriControloState={relatoriControloState}
                    relatorioControlo={relatorioControlo}
                    pecaEntrega={pecaEntrega}
                    fetchRelatorio={fetchRelatorio}
                    closeForm={() => setControloQualidadeFormOpen(false)}
                /> : null}

            </div>
        </Modal>
    )


}